import {
    PETS_ERROR,
    PETS_SAVE_START,
    PETS_SAVE_SUCCESS,
    PetsAction
} from 'actions/pets/PetsActionsTypes';
import { convertToPet, convertToSavePetDto } from 'actions/pets/PetsConverter';
import { PetDto } from 'actions/pets/PetsDtos';
import { ApiClient, createTokenConfig } from 'api/ApiClient';
import { serializeToFormData } from 'api/serializer';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store';
import { RootAction } from 'types/Actions';
import { Pet } from 'types/Pet';

const petsUrl = 'pets';

const errorHandler = (error: unknown): PetsAction => {
    console.error(error);

    return {
        type: PETS_ERROR
    };
};

export const savePetThunk = (
    pet: Pet
): ThunkAction<Promise<Pet | null>, RootState, null, RootAction> => {
    return async (dispatch, getState) => {
        try {
            dispatch(savePetStart());

            const marketplaceId = getState().marketplace.data.id;

            const apiMethod = pet.id ? ApiClient.patch : ApiClient.post;
            const url = pet.id ? `${petsUrl}/${pet.id}` : petsUrl;

            const formData = serializeToFormData({
                pet: convertToSavePetDto(pet, marketplaceId)
            });

            const response = await apiMethod<PetDto>(url, formData, createTokenConfig());

            const savedPet = convertToPet(response.data);

            dispatch(savePetSuccess(savedPet));
            return savedPet;
        } catch (error) {
            dispatch(errorHandler(error));
            return null;
        }
    };
};

const savePetStart = (): PetsAction => {
    return {
        type: PETS_SAVE_START
    };
};

const savePetSuccess = (pet: Pet): PetsAction => {
    return {
        type: PETS_SAVE_SUCCESS,
        payload: { pet }
    };
};
